import { visibleBindings } from "../lib/hotkeys";
import { useHotkeys } from "../store/hotkeys";

/**
 * Таблица горячих клавиш по «?».
 *
 * Рисуется ИЗ ТОЙ ЖЕ таблицы HOTKEYS, которую читает резолвер. Одна таблица,
 * два потребителя — документация физически не может разойтись с поведением, и
 * отдельный тест проверяет, что каждая строка действительно резолвится своим
 * же кодом.
 *
 * Подсказки раскладки («й» под Q) не украшение: привязка идёт по ФИЗИЧЕСКОМУ
 * положению клавиши, и на ЙЦУКЕН оператор видит на клавише не то, что написано
 * в таблице.
 */
export function HotkeyHelp() {
  const open = useHotkeys((s) => s.helpOpen);
  const toggle = useHotkeys((s) => s.toggleHelp);
  const armed = useHotkeys((s) => s.armed);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-6"
      onClick={() => toggle(false)}
    >
      <div
        className="w-full max-w-lg rounded-lg border border-[var(--color-border)] bg-[var(--color-panel)] p-5"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mb-3 flex items-baseline justify-between">
          <h2 className="text-sm font-medium">Горячие клавиши</h2>
          <span className="text-xs text-[var(--color-muted)]">Esc — закрыть</span>
        </div>

        <table className="w-full text-xs">
          <tbody>
            {visibleBindings().map((b) => (
              <tr key={`${b.code}:${b.shift === true}`}>
                <td className="w-24 py-1">
                  <span className="kbd">{b.label}</span>
                  {b.layoutHint && (
                    <span className="ml-1 text-[var(--color-muted)]">({b.layoutHint})</span>
                  )}
                </td>
                <td className="py-1 text-[var(--color-muted)]">{b.description}</td>
              </tr>
            ))}
            <tr>
              <td className="w-24 py-1">
                <span className="kbd">1</span>
                <span className="mx-0.5 text-[var(--color-muted)]">…</span>
                <span className="kbd">9</span>
              </td>
              <td className="py-1 text-[var(--color-muted)]">выбрать пресет размера</td>
            </tr>
          </tbody>
        </table>

        <p className="mt-4 text-xs text-[var(--color-muted)]">
          Верхний ряд клавиш (<span className="kbd">Q</span> <span className="kbd">W</span>) — это
          верхний исход на панели (<span style={{ color: "var(--color-buy)" }}>UP</span>), нижний (
          <span className="kbd">A</span> <span className="kbd">S</span>) —{" "}
          <span style={{ color: "var(--color-sell)" }}>DOWN</span>; слева Maker L1 (встать в стакан
          лучшей ценой, GTC), справа Taker (перейти спред, FAK). Ряды идут в том же порядке, что
          исходы рынка и лесенки. Shift выбирает сторону: без него покупка, с ним — закрытие
          выбранной доли позиции, и только когда позиция есть.
        </p>
        <p className="mt-2 text-xs text-[var(--color-muted)]">
          Клавиши бьют от <b>активной строки</b> панели — аккаунта или когорты, по имени которой
          щёлкнули (она помечена ●). Когорта покупает полным пресетом с каждого годного аккаунта, а
          закрывает каждый аккаунт своей долей. <span className="kbd">⇧C</span> снимает ордера рынка у
          всех аккаунтов набора.
        </p>
        <p className="mt-2 text-xs text-[var(--color-muted)]">
          Быстрые действия работают на странице рынка и только в{" "}
          <span style={{ color: armed ? "var(--color-sell)" : "inherit" }}>боевом режиме</span> — он
          включается мышью на панели и гаснет по Esc, при уходе со страницы, при переходе на
          соседнее окно серии и через пять минут простоя. Клавиши привязаны к положению на
          клавиатуре, поэтому раскладка значения не имеет.
        </p>
      </div>
    </div>
  );
}
